// extracted by mini-css-extract-plugin
module.exports = {"KendoGrid":"AssignmentTable_KendoGrid__1iuyM"};